export class OrderTotalPrice {
    public originalPrice: number;
    public calculatedPrice: number;
    public orderCode: string;
    public isPaid: boolean;
    public collectingDate: Date;
}
